import { render, staticRenderFns } from "./ExchangePopupBefore.vue?vue&type=template&id=bd42c1fe&"
import script from "./ExchangePopupBefore.vue?vue&type=script&lang=ts&"
export * from "./ExchangePopupBefore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports